const config = {};

// getHolidayId :: Date => string
export const getHolidayId = (date) => {
    const dateIso = Date.parse(date);
    for (let key of Object.keys(config)) {
        if (dateIso >= Date.parse(config[key].from) && dateIso <= Date.parse(config[key].to)) {
            return key;
        }
    }
    return 'normal';
};
